import { createDB } from './schema.js';

export const db = createDB();

export { createDB };
